package com.upcominds.expedite.data.auth

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TokenResponseDTO(
    @SerialName("access_token")
    val access_token: String? = null,
    @SerialName("refresh_token")
    val refresh_token: String? = null,
    @SerialName("id_token")
    val id_token: String? = null,
    @SerialName("expires_in")
    val expires_in: Long? = null,
    @SerialName("refresh_expires_in")
    val refresh_expires_in: Long? = null,
    @SerialName("token_type")
    val token_type: String? = null,
    @SerialName("scope")
    val scope: String? = null
)

fun TokenResponseDTO.toTokenSet(
    fallbackRefresh: String?,
    fallbackId: String?
): TokenSet {
    val accessToken = requireNotNull(access_token?.takeIf { it.isNotBlank() }) {
        "The token response did not contain an access token"
    }
    val expiresIn = requireNotNull(expires_in?.takeIf { it > 0L }) {
        "The token response did not contain a valid expiry"
    }
    val now = nowEpochSeconds()
    return TokenSet(
        accessToken = accessToken,
        refreshToken = this.refresh_token?.takeIf { it.isNotBlank() } ?: fallbackRefresh,
        idToken = this.id_token?.takeIf { it.isNotBlank() } ?: fallbackId,
        expiresAtEpochSeconds = now + expiresIn
    )
}
